import MpgInput from "../../../CommonFormComp/MpgInput";
import MpgAutocompleteMulti from "../../../CommonFormComp/MpgAutocompleteMulti";
import MpgAutocompleteSingle from "../../../CommonFormComp/MpgAutocompleteSingle";

const ClientAccountDetailsFields = ({
  rhfFormInstance,
  fetchLabel,
  primaryLangAutocompleteList,
  supportiveLangAutocompleteList,
  currencyAutocompleteList,
  clientTypeAutocompleteList,
  selectedPrimaryLang,
}) => {
  return (
    <>
      <MpgInput
        rhfFormInstance={rhfFormInstance}
        name={"client_acc_name"}
        label={fetchLabel("ClientAccountDetails.ClientAccountName")}
        fullWidth
      />

      <MpgAutocompleteSingle
        rhfFormInstance={rhfFormInstance}
        name={"primary_lang"}
        label={fetchLabel("ClientAccountDetails.PrimaryLanguages")}
        fullWidth
        optionList={primaryLangAutocompleteList || []}
      />

      <MpgAutocompleteMulti
        rhfFormInstance={rhfFormInstance}
        name={"supported_lang"}
        label={fetchLabel("ClientAccountDetails.SupportedLanguages")}
        fullWidth
        optionList={supportiveLangAutocompleteList || []}
        disabled={!selectedPrimaryLang?.id}
      />

      <MpgAutocompleteSingle
        rhfFormInstance={rhfFormInstance}
        name={"CurrencyId"}
        label={fetchLabel("ClientAccountDetails.Currency")}
        fullWidth
        optionList={currencyAutocompleteList || []}
      />

      <MpgAutocompleteSingle
        rhfFormInstance={rhfFormInstance}
        name={"ClientType"}
        label={fetchLabel("ClientAccountDetails.Type")}
        fullWidth
        optionList={clientTypeAutocompleteList || []}
      />
    </>
  );
};

export default ClientAccountDetailsFields;
